import { EditorModes, isSystemPart, ReviewType } from "@buildwithflux/models";
import { ElementHelper } from "../../elements";
import { getFootprints, getTopLevelLayouts } from "../../nodes";
import { getProblemTypeKeyFromReviewType } from "../types";
export class MissingFootprintsValidator {
    reviewType = ReviewType.DesignRuleCheckMissingFootprints;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    async checkForProblems({ documentUid, elements }) {
        const needsFootprint = Object.entries(elements ?? {}).filter(([_key, element]) => {
            // Special case for system parts
            if (isSystemPart(element.part_uid))
                return false;
            // Ignore invalid elements
            if (!ElementHelper.isValidLayoutElement(element, documentUid))
                return false;
            // Without layout nodes
            const nodes = element.part_version_data_cache.pcbLayoutNodes;
            if (!nodes)
                return true;
            // General case
            const footprints = getFootprints(nodes);
            const layouts = getTopLevelLayouts(nodes);
            return footprints.length === 0 && layouts.length === 0;
        });
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: needsFootprint.map((el) => ({
                problemTypeKey: this.problemTypeKey,
                key: `${this.problemTypeKey}_${el[0]}`,
                affectedItems: [{ type: "element", uid: el[0] }],
                affectedViews: [EditorModes.pcb, EditorModes.schematic],
            })),
        };
    }
}
//# sourceMappingURL=MissingFootprintsValidator.js.map